import { styled } from '@mui/system'

export const HeaderTitleContainer = styled('div')`
    display: flex;
    gap: 9px;
    align-items: center;
`
